import { useContext, useState, Suspense, lazy } from "react";
import { AnimatePresence } from "framer-motion";

import { SignupsAppState } from "Signups/state.js";
import { useIsSignupClosed } from "Signups/SharedComponents/useIsSignupClosed";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";

const ConfirmationEmailEditor = lazy(() => import("./ConfirmationEmailEditor"));

export default function EditConfirmationEmail() {
  const [
    {
      currentSignupList: {
        ID: signupListID,
        signupListVerbs,
        title,
        description,
        signupItems,
        customEmailConfirmationData,
      },
    },
  ] = useContext(SignupsAppState);

  const { isArchived } = useIsSignupClosed();

  const { subject, body } = customEmailConfirmationData ?? {};

  const [showConfirmationEmailEditor, setShowConfirmationEmailEditor] =
    useState(false);

  const itemName = signupItems[0]?.title;

  return (
    <>
      <FnrButton
        className="customize_email_panel"
        onClick={() =>
          setShowConfirmationEmailEditor((prevShowing) => !prevShowing)
        }
        disabled={isArchived}
        color="blue"
      >
        <ButtonIcon fas fa-envelope-open-text />
        <ButtonText>Edit Confirmation Email</ButtonText>
      </FnrButton>
      <AnimatePresence>
        {showConfirmationEmailEditor && (
          <Suspense fallback>
            <ConfirmationEmailEditor
              signupListID={signupListID}
              initialSubject={subject ?? `Signup Confirmation for ${title}`}
              initialBody={body ?? description}
              title={title}
              description={description}
              itemName={itemName}
              signupTitle={title}
              onClose={() => setShowConfirmationEmailEditor(false)}
              verbs={signupListVerbs}
            />
          </Suspense>
        )}
      </AnimatePresence>
    </>
  );
}
